module.exports = __webpack_public_path__ + "img/wxpay.ea780cdd.svg";